/// <reference path="../../../../../../packages/client-types/index.d.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "model/tree", "model/readonlytree", "model/computed", "model/compute_wiring", "@mindbreeze/api-clients", "marked", "api/v2/search", "backbone", "underscore", "client/client-config", "i18n/i18n", "@mindbreeze/client-web-components/src/utils/theme", "lit", "./result", "model/properties"], function (require, exports, tree_1, readonlytree_1, computed_1, compute_wiring_1, api_clients_1, marked_1, search_1, backbone_1, underscore_1, client_config_1, i18n_1, theme_1, lit_1, result_1, properties_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RAGAnswerLegacyModelAdapter = exports.SearchModelTriggerStrategyType = exports.AnswerModel = exports.AnswerComputeWiring = exports.AnswerOutputModel = exports.AnswerInputModel = exports.StreamRequestStatus = void 0;
    exports.createChatClient = createChatClient;
    exports.createRAGPipelineAnswerModel = createRAGPipelineAnswerModel;
    exports.createRAGMessageTemplatesAnswerModel = createRAGMessageTemplatesAnswerModel;
    exports.createSearchResponseAnswerModel = createSearchResponseAnswerModel;
    tree_1 = __importDefault(tree_1);
    readonlytree_1 = __importDefault(readonlytree_1);
    computed_1 = __importDefault(computed_1);
    compute_wiring_1 = __importDefault(compute_wiring_1);
    search_1 = __importDefault(search_1);
    backbone_1 = __importDefault(backbone_1);
    underscore_1 = __importDefault(underscore_1);
    client_config_1 = __importDefault(client_config_1);
    i18n_1 = __importDefault(i18n_1);
    properties_1 = __importDefault(properties_1);
    function createChatClient(options) {
        return new api_clients_1.ChatV1BetaClient(options);
    }
    var StreamRequestStatus;
    (function (StreamRequestStatus) {
        StreamRequestStatus["Unitialized"] = "unitialized";
        StreamRequestStatus["AwaitingData"] = "is_awaiting_data";
        StreamRequestStatus["IsStreaming"] = "is_streaming";
        StreamRequestStatus["StreammingComplete"] = "streaming_complete";
        StreamRequestStatus["RequestFailed"] = "request_failed";
    })(StreamRequestStatus || (exports.StreamRequestStatus = StreamRequestStatus = {}));
    function makeErrorText(errorMessage, theme) {
        var _a, _b;
        const template = (0, lit_1.html) `
    <div class="mb-answer-error flex space-x-1">
      <insight-stock-icon 
        name="exclamation"
        altText=""
        color=${"" + (0, theme_1.resolveCssVarValue)((_b = (_a = theme.themes) === null || _a === void 0 ? void 0 : _a.base.colors) === null || _b === void 0 ? void 0 : _b.error, theme) || 'currentColor'}
        height="20"
        width="20"
      >
      </insight-stock-icon>
      <div class="text">${errorMessage}</div>
    </div>
    `;
        const container = document.createElement('div');
        (0, lit_1.render)(template, container);
        return container.innerHTML;
    }
    class AnswerInputModel extends tree_1.default {
        validate() {
            var _a, _b, _c, _d;
            return (((_a = this.attributes.retrieval_options) === null || _a === void 0 ? void 0 : _a.use_inputs) === false ||
                (this.attributes.inputs != null && ((_b = this.attributes) === null || _b === void 0 ? void 0 : _b.inputs.length) > 0)) ||
                ((_d = (_c = this.attributes.generation_options) === null || _c === void 0 ? void 0 : _c.message_templates) === null || _d === void 0 ? void 0 : _d.length) > 0;
        }
    }
    exports.AnswerInputModel = AnswerInputModel;
    // The Idea is to successively load given the stream events.
    class AnswerOutputModel extends readonlytree_1.default {
    }
    exports.AnswerOutputModel = AnswerOutputModel;
    function escapeHTML(content) {
        return content.replace(/[<>"'\/]/g, function (char) {
            return {
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
                "/": "&#47;"
            }[char] || char;
        });
    }
    function parseMarkdown(text) {
        if (!text) {
            return "";
        }
        function cleanUrl(href) {
            try {
                href = encodeURI(href).replace(/%25/g, '%');
            }
            catch (e) {
                return null;
            }
            return href;
        }
        var customMarked = new marked_1.Marked({
            hooks: {
                postprocess: function (html) { return html; }
            },
            extensions: [],
            renderer: {
                link: function (link) {
                    var tokens = link.tokens;
                    var href = link.href;
                    var title = link.title;
                    var text = this.parser.parseInline(tokens);
                    var cleanHref = cleanUrl(href);
                    if (cleanHref === null) {
                        return text;
                    }
                    href = cleanHref;
                    let out = '<a href="' + href + '" target="_blank" rel="noreferrer"';
                    if (title) {
                        out += ' title="' + title + '"';
                    }
                    out += '>' + text + '</a>';
                    return out;
                },
                html: function (html) { return escapeHTML(html.text); },
            },
            gfm: true,
            breaks: true,
        });
        var tokens = customMarked.lexer(text);
        var renderedTokens = tokens.map(function (token) {
            return customMarked.parse(token.raw);
        });
        var parsedText = renderedTokens.join(" ");
        return parsedText;
    }
    class BaseAnswerComputation {
        constructor(wiring, options) {
            this.input = wiring.input;
            this.output = wiring.output;
            this.wiring = wiring;
            this.options = options;
        }
        getClientExtensions() {
            var _a, _b;
            return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.getClientExtensions();
        }
        getResultPropertyEnrichmentHandler() {
            const clientExtensions = this.getClientExtensions();
            if (!clientExtensions) {
                return;
            }
            var factory = clientExtensions.getResultPropertiesEnrichmentHandlerFactoryV1 &&
                clientExtensions.getResultPropertiesEnrichmentHandlerFactoryV1();
            return factory && underscore_1.default.isFunction(factory.createHandler) && factory.createHandler({});
        }
        // BEGIN grouping retrieval_details into sources =============================
        static createTextSnippetFromAnswer(answer) {
            var _a;
            // TODO 
            return { id: "textsnippets", data: [{ value: { textsnippet: {
                                text_region: answer.text,
                                property_name: answer.property_name,
                                pos_offset: (_a = answer.text) === null || _a === void 0 ? void 0 : _a.text_start_pos
                            }
                        }
                    }] };
        }
        groupWithCitation(sources, propsList) {
            const state = {
                sourcesMapByIndex: new Map(),
                citationid2ResultAndSnippetMap: {},
                groupByFQCategoryKey: new Map(),
                sources
            };
            return sources.reduce((state, result, answerIndex, answers) => {
                var _a, _b, _c;
                const index = (_a = result.citationdocumentnumber) === null || _a === void 0 ? void 0 : _a.value;
                const citationid = (_b = result.citationid) === null || _b === void 0 ? void 0 : _b.value;
                let snippetOffset = 0;
                if (state.sourcesMapByIndex.has(index)) {
                    let newSnippets = (_c = result.textsnippets) === null || _c === void 0 ? void 0 : _c.accessor;
                    const entry = state.sourcesMapByIndex.get(index);
                    const existingSnippets = entry.result.textsnippets.accessor;
                    const resultList = entry.result.textsnippets.accessor;
                    snippetOffset = existingSnippets.length;
                    resultList.elementValues = existingSnippets.elementValues.concat(newSnippets.elementValues);
                }
                else {
                    state.sourcesMapByIndex.set(index, { result, model: new properties_1.default(propsList[answerIndex], {}), resultIndex: index });
                }
                if (citationid != null) {
                    state.citationid2ResultAndSnippetMap[citationid] = { resultIndex: index, snippetOffset };
                }
                return state;
            }, state);
        }
        groupWithoutCitation(sources, propsList) {
            const state = {
                sourcesMapByIndex: new Map(),
                citationid2ResultAndSnippetMap: {},
                groupByFQCategoryKey: new Map(),
                sources
            };
            function getOrCreateIndexNumberFromAnswer(indexMap, prop) {
                var _a, _b, _c, _d;
                let fqcategory = "";
                if ((_a = prop.fqcategory) === null || _a === void 0 ? void 0 : _a.value) {
                    fqcategory = prop.fqcategory.value;
                }
                else if (((_b = prop.category) === null || _b === void 0 ? void 0 : _b.value) && ((_c = prop.categoryinstance) === null || _c === void 0 ? void 0 : _c.value)) {
                    fqcategory = prop.category.value + ":" + prop.categoryinstance.value;
                }
                let key = fqcategory + ":" + ((_d = prop['mes:key']) === null || _d === void 0 ? void 0 : _d.value);
                if (!indexMap.has(key)) {
                    indexMap.set(key, indexMap.size + 1);
                }
                return indexMap.get(key);
            }
            return sources.reduce((state, result, answerIndex, answers) => {
                var _a;
                let index = getOrCreateIndexNumberFromAnswer(state.groupByFQCategoryKey, result);
                let snippetOffset = 0;
                if (state.sourcesMapByIndex.has(index)) {
                    let newSnippets = (_a = result.textsnippets) === null || _a === void 0 ? void 0 : _a.accessor;
                    const entry = state.sourcesMapByIndex.get(index);
                    const existingSnippets = entry.result.textsnippets.accessor;
                    const resultList = entry.result.textsnippets.accessor;
                    snippetOffset = existingSnippets.length;
                    resultList.elementValues = existingSnippets.elementValues.concat(newSnippets.elementValues);
                }
                else {
                    state.sourcesMapByIndex.set(index, { result, model: new properties_1.default(propsList[answerIndex], {}), resultIndex: index });
                }
                return state;
            }, state);
        }
        buildSourcesFromRetrivalDetailsAnswers(answers) {
            let propList = new Array();
            let sources = answers.map((answer) => {
                let props = Object.assign({}, answer.properties);
                props["textsnippets"] = BaseAnswerComputation.createTextSnippetFromAnswer(answer);
                propList.push(props);
                return (0, result_1.createResultPropertiesFromPropertiesData)(props);
            });
            const groupAnswersFunction = sources.every((source) => {
                var _a;
                return ((_a = source.citationdocumentnumber) === null || _a === void 0 ? void 0 : _a.value) != null;
            }) ? this.groupWithCitation.bind(this) : this.groupWithoutCitation.bind(this);
            let result = groupAnswersFunction(sources, propList);
            // TODO encapsulate in a single assignable
            return result;
        }
        parseAndEnrichAnswers(answers) {
            return __awaiter(this, void 0, void 0, function* () {
                const parsedAnswers = search_1.default.SearchResponse.parseAnswers(answers, {});
                const enrichedAnswerpromises = parsedAnswers.map(answer => search_1.default.SearchResponse.adaptProperties(answer, { section: "answers" }, this.getResultPropertyEnrichmentHandler()));
                return yield Promise.all(enrichedAnswerpromises);
            });
        }
        // END grouping retrieval_details into sources =============================
        // TODO provide adaptProperties as async function
        perform(compInfo) {
            return __awaiter(this, void 0, void 0, function* () {
                throw new Error("Not Implemented");
            });
        }
    }
    class RetrievalDetailsAnswerComputation extends BaseAnswerComputation {
        perform(compInfo) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                this.output.reset({});
                const answers = this.input.get("generation_options.answers");
                if (!answers || answers.length == 0) {
                    return;
                }
                this.output.reset({ computing: true, question: this.input.get("inputs"), generated_text: "", retrieval_details: { answers: [] }, generate_count: 0, stream_request_status: StreamRequestStatus.AwaitingData });
                const topAnswer = answers[0];
                const restOfANswers = answers.slice(1);
                let html = "";
                if (topAnswer.text) {
                    html += topAnswer.text.context_before;
                    html += "<b>" + topAnswer.text.text + "</b>";
                    html += topAnswer.text.context_after;
                }
                let answer = {};
                answer.question = this.input.get("inputs");
                answer.stream_request_status = StreamRequestStatus.StreammingComplete;
                answer.generated_text = html;
                answer.unparsed_generated_text = answer.generated_text;
                answer.computing = false;
                const enrichedAnswers = yield this.parseAndEnrichAnswers(answers);
                answer.retrieval_details = {
                    answers: enrichedAnswers
                };
                const builtSources = this.buildSourcesFromRetrivalDetailsAnswers(enrichedAnswers);
                answer.sources = {
                    results: Array.from((_a = builtSources === null || builtSources === void 0 ? void 0 : builtSources.sourcesMapByIndex) === null || _a === void 0 ? void 0 : _a.values()),
                    citation_map: builtSources === null || builtSources === void 0 ? void 0 : builtSources.citationid2ResultAndSnippetMap
                };
                yield this.output.load(answer, { merge: false });
            });
        }
    }
    function loadingAnswerOutput(question) {
        const loadingText = "<insight-answer-loading></insight-answer-loading>";
        return {
            computing: true,
            question,
            retrieval_details: { answers: [] },
            generated_text: loadingText,
            generate_count: 0,
            stream_request_status: StreamRequestStatus.AwaitingData
        };
    }
    function errorAnswerOutput(theme) {
        const text = makeErrorText((0, i18n_1.default)('ai_answer_generic_error_message'), theme);
        return {
            computing: null,
            question: '',
            retrieval_details: { answers: [] },
            generated_text: text,
            generate_count: 0,
            stream_request_status: StreamRequestStatus.RequestFailed
        };
    }
    function requiresModelid(inputData) {
        var _a;
        return (!inputData.model_id &&
            !inputData.pipeline_id &&
            !inputData.pipeline_key &&
            !((_a = inputData.generation_options) === null || _a === void 0 ? void 0 : _a.message_templates));
    }
    class ChatClientGenerateTextAnswerComputation extends BaseAnswerComputation {
        createChatClient() {
            var _a, _b;
            const baseUrl = ((_a = this.options.channelInfo) === null || _a === void 0 ? void 0 : _a.url) + "../chat/v1beta";
            const chatClientOptions = { url: baseUrl, channelOptions: (_b = this.options.channelInfo) === null || _b === void 0 ? void 0 : _b.channelOptions };
            return new api_clients_1.ChatV1BetaClient(chatClientOptions);
        }
        perform(compInfo) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                // if we are waiting on the answers we will just reset it here and set it into computing?
                const client = this.createChatClient();
                const input = Object.assign({}, this.input.get());
                // TODO move?
                try {
                    if (requiresModelid(input)) {
                        let modelsAndSettings = this.modelsAndSettings;
                        if (!modelsAndSettings) {
                            modelsAndSettings = yield client.getConversationsModelsAndSettings({});
                            this.modelsAndSettings = modelsAndSettings;
                        }
                        if (((_a = modelsAndSettings.models) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            // default model id is using the first model
                            const modelid = modelsAndSettings.models[0].id;
                            input.model_id = modelid;
                        }
                    }
                }
                catch (e) {
                    console.log("Failed to resolve modelid", e);
                }
                const tokenIterable = client.generateTextStream(this.wiring.effectiveInput(input), { signal: compInfo.abortController.signal });
                return yield this._perform(tokenIterable, compInfo);
            });
        }
        _perform(tokenStream, compInfo) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, tokenStream_1, tokenStream_1_1;
                var _b, e_1, _c, _d;
                var _e, _f, _g, _h, _j, _k, _l;
                const answerModel = this.output;
                answerModel.reset(loadingAnswerOutput(this.input.get("inputs")));
                let isFirst = true;
                try {
                    try {
                        for (_a = true, tokenStream_1 = __asyncValues(tokenStream); tokenStream_1_1 = yield tokenStream_1.next(), _b = tokenStream_1_1.done, !_b; _a = true) {
                            _d = tokenStream_1_1.value;
                            _a = false;
                            const tokenEvent = _d;
                            // console.log(tokenEvent);
                            if (compInfo.localComputationId != compInfo.getCurrentComputationId()) {
                                console.log("New Compuation, aborting", compInfo.getCurrentComputationId());
                                break;
                            }
                            const answer = answerModel.get();
                            try {
                                if (tokenEvent.generated_text) {
                                    // assume streaming complete?
                                    answer.stream_request_status = StreamRequestStatus.StreammingComplete;
                                    answer.unparsed_generated_text = tokenEvent.generated_text;
                                    answer.computing = false;
                                }
                                else if (tokenEvent.token.text) {
                                    answer.stream_request_status = StreamRequestStatus.IsStreaming;
                                    if (!isFirst) {
                                        answer.unparsed_generated_text += tokenEvent.token.text;
                                    }
                                    else {
                                        answer.unparsed_generated_text = tokenEvent.token.text;
                                        isFirst = false;
                                    }
                                }
                                if (tokenEvent.retrieval_details) {
                                    let retrievalDetails = Object.assign({}, tokenEvent.retrieval_details);
                                    if (retrievalDetails.answers) {
                                        // TODO channel
                                        const enrichedAnswers = yield this.parseAndEnrichAnswers(retrievalDetails.answers);
                                        const builtSources = this.buildSourcesFromRetrivalDetailsAnswers(enrichedAnswers);
                                        answer.sources = {
                                            results: Array.from((_e = builtSources === null || builtSources === void 0 ? void 0 : builtSources.sourcesMapByIndex) === null || _e === void 0 ? void 0 : _e.values()),
                                            citation_map: builtSources === null || builtSources === void 0 ? void 0 : builtSources.citationid2ResultAndSnippetMap
                                        };
                                        retrievalDetails.answers = enrichedAnswers;
                                    }
                                    // TODO formatted answers
                                    answer.retrieval_details = retrievalDetails;
                                }
                                if (tokenEvent.citation_details) {
                                    answer.citation_details = Object.assign(answer.citation_details || {}, tokenEvent.citation_details);
                                    if (tokenEvent.citation_details.generated_text_without_citations) {
                                        answer.unparsed_generated_text_without_citations = tokenEvent.citation_details.generated_text_without_citations;
                                    }
                                }
                                if (answer.generate_count !== undefined) {
                                    answer.generate_count++;
                                }
                                answer.generated_text = parseMarkdown(answer.unparsed_generated_text);
                                // TODO call the adaptProperties function 
                                yield answerModel.load(answer, { merge: false });
                            }
                            catch (e) {
                                (_f = console === null || console === void 0 ? void 0 : console.log) === null || _f === void 0 ? void 0 : _f.call(console, "Exception during handling of events", e);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (!_a && !_b && (_c = tokenStream_1.return)) yield _c.call(tokenStream_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                catch (e) {
                    (_g = console === null || console === void 0 ? void 0 : console.warn) === null || _g === void 0 ? void 0 : _g.call(console, "Exception during event iteration", e);
                    const theme = ((_j = (_h = this.options) === null || _h === void 0 ? void 0 : _h.application) === null || _j === void 0 ? void 0 : _j.getThemeDescriptorModel().attributes) || {};
                    if (!((_l = (_k = compInfo.abortController) === null || _k === void 0 ? void 0 : _k.signal) === null || _l === void 0 ? void 0 : _l.aborted)) {
                        answerModel.reset(errorAnswerOutput(theme));
                    }
                    else {
                        if (isFirst) {
                            yield answerModel.load(({ computing: false, generated_text: "" }), { merge: true });
                        }
                        else {
                            yield answerModel.load(({ computing: false }), { merge: true });
                        }
                    }
                }
            });
        }
    }
    var AddAnswersFromResultsMode;
    (function (AddAnswersFromResultsMode) {
        AddAnswersFromResultsMode["AppendToAnswers"] = "true";
        AddAnswersFromResultsMode["ReplaceAnswers"] = "replaceanswers";
        AddAnswersFromResultsMode["Disabled"] = "false";
        AddAnswersFromResultsMode["IfNoAnswers"] = "noanswers";
    })(AddAnswersFromResultsMode || (AddAnswersFromResultsMode = {}));
    function getSearchRequest(searchRequest, options) {
        if (!searchRequest) {
            return;
        }
        searchRequest = Object.assign({}, searchRequest);
        let user = searchRequest.user;
        let source_context = searchRequest.source_context;
        // in embedded ai-answer inside searchcontainer when user removes the search input 
        const userSearchInputPattern = /^searchcontainer_user_query_search_view\w*\d+$/;
        const deleteUserQuerySearchView = (searchObject) => {
            if (!searchObject.constraints)
                return;
            searchObject.constraints = searchObject.constraints.filter((constraint) => !(constraint && constraint.id && constraint.id.match(userSearchInputPattern)));
        };
        const deleteUserFilterConstrainet = (searchObject) => {
            if (!searchObject.constraints)
                return;
            searchObject.constraints = searchObject.constraints.filter((constraint) => (constraint && constraint.id && constraint.id.match(userSearchInputPattern)));
        };
        function deletePropertyIfConditionMet(keepProperty, object, cb, property) {
            if ((keepProperty === "false" || keepProperty === false) && object) {
                if (property && object[property]) {
                    delete object[property];
                }
                if (cb) {
                    cb(object);
                }
            }
        }
        // remove user.query since it is "inputs"
        //  options.useUserInput controles the request "inputs"
        var keepUserQuery = false;
        deletePropertyIfConditionMet(keepUserQuery, user, null, "query");
        //focus to remove object.constraint.obj[id] == userSearchInputPatern
        deletePropertyIfConditionMet(options.useSearchInput, user, deleteUserQuerySearchView, null);
        //focus to remove object.constraint.obj[id] != userSearchInputPatern
        deletePropertyIfConditionMet(options.useUserConstraints, user, deleteUserFilterConstrainet, null);
        deletePropertyIfConditionMet(options.useSourceContextConstraints, source_context, null, "constraints");
        return searchRequest;
    }
    function EventsMixin() { return this; }
    ;
    Object.assign(EventsMixin.prototype, backbone_1.default.Events);
    // Strategy
    class SearchModelTriggerStrategyBase extends EventsMixin {
        constructor(searchModel, answerComputeWiring, application) {
            super();
            this.answerComputeWiring = answerComputeWiring;
            this.application = application;
            this.setSearchModel(searchModel);
        }
        setSearchModel(model) {
            var _a, _b;
            if (this.searchModel == model) {
                return;
            }
            if (this.searchModel) {
                if ((_a = this.answerComputeWiring.searchModelOptions) === null || _a === void 0 ? void 0 : _a.enableComputingWhenGenerate) {
                    this.searchModel.unregisterComputationTaskProvider(this.answerComputeWiring);
                }
                this.stopListening(this.searchModel);
            }
            this.searchModel = model;
            if (((_b = this.answerComputeWiring.searchModelOptions) === null || _b === void 0 ? void 0 : _b.enableComputingWhenGenerate) && this.searchModel && this.searchModel.registerComputationTaskProvider) {
                this.searchModel.registerComputationTaskProvider(this.answerComputeWiring);
            }
        }
        onSearchModelInputChange() {
            var _a, _b, _c, _d, _e;
            // Always reset if input changes.
            this.answerComputeWiring.abortComputation();
            this.answerComputeWiring.input.set("inputs", this.getUnparsedUserQuery(), { silent: true });
            if (((_b = (_a = this.searchModel) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.validate) && !((_d = (_c = this.searchModel) === null || _c === void 0 ? void 0 : _c.input) === null || _d === void 0 ? void 0 : _d.validate())
                || this.answerComputeWiring.input.validate && !this.answerComputeWiring.input.validate()) {
                // thisis not valid so we can clear it.
                this.answerComputeWiring.output.reset({});
                return false;
            }
            if ((_e = this.answerComputeWiring.searchModelOptions) === null || _e === void 0 ? void 0 : _e.clearAnswerOnChange) {
                if (this.answerComputeWiring.input.validate && this.answerComputeWiring.input.validate()) {
                    this.answerComputeWiring.output.reset(loadingAnswerOutput(this.getUnparsedUserQuery()));
                }
            }
            return true;
        }
        getUnparsedUserQuery() {
            if (!this.searchModel) {
                return;
            }
            var userQueryPath = this.application.getUnparsedUserQueryPath();
            if (!userQueryPath) {
                return;
            }
            const model = this.searchModel;
            return model && model.input && model.input.get(userQueryPath) || '';
        }
    }
    class SearchModelTriggerComputeOnInputChange extends SearchModelTriggerStrategyBase {
        setSearchModel(searchModel) {
            if (searchModel == this.searchModel) {
                return;
            }
            super.setSearchModel(searchModel);
            if (this.searchModel) {
                this.listenTo(this.searchModel.input, "change", this.onSearchModelInputChange);
            }
        }
        onSearchModelInputChange() {
            var _a;
            if (!super.onSearchModelInputChange()) {
                return;
            }
            const searchRequest = this.answerComputeWiring.getSearchRequest();
            if (searchRequest) {
                this.answerComputeWiring.input.set("retrieval_options", { search_request: searchRequest,
                    skip_retrieval: false,
                    use_inputs: ((_a = this.answerComputeWiring.searchModelOptions) === null || _a === void 0 ? void 0 : _a.useUserInput) === false ? false : true });
            }
            else {
                this.answerComputeWiring.input.change();
            }
            return true;
        }
    }
    class SearchModelPropagateAnswersAfterComputation extends SearchModelTriggerStrategyBase {
        constructor(searchModel, answerComputeWiring, application) {
            super(searchModel, answerComputeWiring, application);
            this.searchModelOptions = this.answerComputeWiring.searchModelOptions;
        }
        setSearchModel(searchModel) {
            if (searchModel == this.searchModel) {
                return;
            }
            super.setSearchModel(searchModel);
            if (this.searchModel) {
                this.listenTo(this.searchModel, "computed", this.onSearchModelComputed);
                this.listenTo(this.searchModel.input, "change", this.onSearchModelInputChange);
            }
        }
        onSearchModelComputed() {
            var _a, _b, _c;
            // _nextPageCount zero means the first page
            const isValid = this.searchModel.input.validate();
            if (!this.searchModel || this.searchModel._nextPageCount || !isValid) {
                return;
            }
            let answers = [];
            const searchAnswers = search_1.default.SearchResponse.answersToJSON(this.searchModel.output.get("answers"));
            if (((_a = this.searchModelOptions) === null || _a === void 0 ? void 0 : _a.addAnswersFromResults) == AddAnswersFromResultsMode.ReplaceAnswers ||
                ((_b = this.searchModelOptions) === null || _b === void 0 ? void 0 : _b.addAnswersFromResults) == AddAnswersFromResultsMode.IfNoAnswers && !searchAnswers.length) {
                answers = this.makeAnswersFromResults();
            }
            else if (((_c = this.searchModelOptions) === null || _c === void 0 ? void 0 : _c.addAnswersFromResults) == AddAnswersFromResultsMode.AppendToAnswers) {
                answers = searchAnswers.concat(this.makeAnswersFromResults());
            }
            else {
                answers = searchAnswers;
            }
            this.answerComputeWiring.input.set("generation_options.answers", answers, { silent: true });
            this.answerComputeWiring.input.set("retrieval_options.skip_retrieval", true);
        }
        makeAnswersFromResults() {
            var _a, _b, _c, _d;
            const answers = [];
            const retrievedContextLimit = ((_a = this.searchModelOptions) === null || _a === void 0 ? void 0 : _a.retrievedContextLimit) || 5;
            let results = this.searchModel.output.get('resultset.results') || [];
            if (results.length > retrievedContextLimit) {
                results = results.slice(0, retrievedContextLimit);
            }
            for (const result of results) {
                const propertyDefinitions = (_b = this.searchModelOptions.resultAnswerMustacheTemplate) === null || _b === void 0 ? void 0 : _b.getProperties();
                const answer = new properties_1.default(result.properties, { propertyDefinitions: propertyDefinitions });
                const text = (_d = (_c = this.searchModelOptions) === null || _c === void 0 ? void 0 : _c.resultAnswerMustacheTemplate) === null || _d === void 0 ? void 0 : _d.render(answer);
                answers.push({
                    text: { text: text },
                    properties: result.originalResponseProperties
                });
            }
            return answers;
        }
    }
    class AnswerComputeWiring extends compute_wiring_1.default {
        constructor(input, output, options) {
            // super calls inititalize
            super(input, output, options);
            this.computationTask = Promise.resolve();
        }
        initialize(input, output, options) {
            if (!options.answerComputationClass || !options.answerComputationOptions) {
                throw new Error("answerComputationClass must be defined");
            }
            this.answerComputation = new options.answerComputationClass(this, options.answerComputationOptions);
            this.searchModelOptions = options.searchModelOptions;
            this.searchModel = options.searchModel;
            if (options.searchModelTriggerStrategyClass) {
                this.searchModelTriggerStrategy = new options.searchModelTriggerStrategyClass(this.searchModel, this, options.application);
            }
        }
        setSearchModel(searchModel) {
            // register and deregister searchModel
            // TODO register either on input change or computed to trigger
            this.searchModel = searchModel;
            if (this.searchModelTriggerStrategy) {
                this.searchModelTriggerStrategy.setSearchModel(searchModel);
            }
        }
        effectiveInput(generateTextRequest) {
            var _a, _b, _c, _d, _e;
            // TODO Presets
            if (!((_a = generateTextRequest.retrieval_options) === null || _a === void 0 ? void 0 : _a.skip_retrieval)) {
                // update the searchRequest
                let searchRequest = this.getSearchRequest();
                generateTextRequest = JSON.parse(JSON.stringify(generateTextRequest));
                if (searchRequest) {
                    if ((_d = (_c = (_b = this.answerComputation) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.channelInfo) === null || _d === void 0 ? void 0 : _d.prepareRequest) {
                        searchRequest.path = "search";
                        try {
                            this.answerComputation.options.channelInfo.prepareRequest(searchRequest);
                        }
                        catch (e) {
                            console.log("Failed to call prepareRequest", e);
                        }
                        if (searchRequest.user_context) {
                            searchRequest.user_context.service_url = this.answerComputation.options.channelInfo.url + searchRequest.path;
                        }
                        delete searchRequest.path;
                    }
                    generateTextRequest.retrieval_options.search_request = searchRequest;
                }
            }
            if ((_e = generateTextRequest.citation_options) === null || _e === void 0 ? void 0 : _e.enable_citation) {
                generateTextRequest.citation_options.citationid_prefix = underscore_1.default.uniqueId("citation_");
            }
            return generateTextRequest;
        }
        getSearchRequest(searchModel) {
            searchModel = searchModel || this.searchModel;
            if (!searchModel || !this.searchModelOptions) {
                return undefined;
            }
            return getSearchRequest(searchModel.input.toJSON(), this.searchModelOptions);
        }
        abortComputation() {
            var _a;
            (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort();
        }
        getCurrentComputationId() {
            return this.computationId;
        }
        compute(ignored, options) {
            return __awaiter(this, void 0, void 0, function* () {
                this.computationTask = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    const input = this.input;
                    if (this.input && this.input.validate && !this.input.validate()) {
                        reject();
                        return;
                    }
                    // abort existing computations
                    const computationId = underscore_1.default.uniqueId("computation");
                    this.computationId = computationId;
                    if (this.abortController) {
                        this.abortController.abort();
                    }
                    this.abortController = new AbortController();
                    const computationInfo = {
                        localComputationId: computationId,
                        abortController: this.abortController,
                        getCurrentComputationId: this.getCurrentComputationId.bind(this)
                    };
                    if (input.get("stream") === false) {
                        throw new Error("stream=false is unsupported");
                    }
                    this.trigger("computing");
                    try {
                        yield this.answerComputation.perform(computationInfo);
                        resolve();
                    }
                    catch (e) {
                        console.log("Failed to compute", e);
                        reject();
                    }
                    finally {
                        this.trigger("computed");
                    }
                }));
            });
        }
        getComputationTask() {
            return this.computationTask;
        }
    }
    exports.AnswerComputeWiring = AnswerComputeWiring;
    class AnswerModel extends computed_1.default {
        constructor(wiring, options) {
            super(wiring, options);
        }
        setSearchModel(searchModel) {
            this.wiring.setSearchModel(searchModel);
        }
        get searchModel() {
            return this.wiring.searchModel;
        }
        abortComputation() {
            this.wiring.abortComputation();
        }
        destroy() {
            this.wiring.setSearchModel(null);
        }
    }
    exports.AnswerModel = AnswerModel;
    var SearchModelTriggerStrategyType;
    (function (SearchModelTriggerStrategyType) {
        SearchModelTriggerStrategyType["None"] = "none";
        SearchModelTriggerStrategyType["TriggerOnInputChange"] = "oninputchange";
        SearchModelTriggerStrategyType["TriggerOnComputed"] = "oncomputed";
    })(SearchModelTriggerStrategyType || (exports.SearchModelTriggerStrategyType = SearchModelTriggerStrategyType = {}));
    function searchModelTriggerStrategyClassFromType(triggerType) {
        if (triggerType === undefined) {
            return;
        }
        switch (triggerType) {
            case SearchModelTriggerStrategyType.None:
                return;
            case SearchModelTriggerStrategyType.TriggerOnComputed:
                return SearchModelPropagateAnswersAfterComputation;
            case SearchModelTriggerStrategyType.TriggerOnInputChange:
                return SearchModelTriggerComputeOnInputChange;
        }
    }
    function prepareAnswerInput(attributes) {
        attributes.stream = true;
        attributes.parameters = Object.assign(attributes.parameters || {}, { retrieval_details: true });
        if ("pipeline_key" in attributes
            || "pipeline_id" in attributes
            || "model_id" in attributes) {
            // per default enable citaiton if pipeline is used
            if (!attributes.citation_options || attributes.citation_options.enable_citation === undefined) {
                if (!attributes.citation_options) {
                    attributes.citation_options = {};
                }
                attributes.citation_options.enable_citation = true;
            }
        }
        return attributes;
    }
    // either model_id, pipeline_id, pipeline_key has to be set.
    function createRAGPipelineAnswerModel(attributes, options, searchModel, searchModelTriggerStrategy, searchModelOptions) {
        // here we should differntiate between current attrbutes and presets.
        // yes if parts of the search request change for instance.
        const input = new AnswerInputModel(prepareAnswerInput(attributes));
        const output = new AnswerOutputModel({});
        const wiringOptions = {
            answerComputationClass: ChatClientGenerateTextAnswerComputation,
            answerComputationOptions: options,
            searchModel,
            searchModelTriggerStrategyClass: searchModelTriggerStrategyClassFromType(searchModelTriggerStrategy),
            silent: true,
            application: options.application,
            searchModelOptions,
            answerInputPresets: attributes
        };
        const wiring = new AnswerComputeWiring(input, output, wiringOptions);
        return new AnswerModel(wiring, {});
    }
    function createRAGMessageTemplatesAnswerModel(attributes, options, searchModel, searchModelTriggerStrategy, searchModelOptions) {
        const input = new AnswerInputModel(prepareAnswerInput(attributes));
        const output = new AnswerOutputModel({});
        const wiringOptions = {
            answerComputationClass: ChatClientGenerateTextAnswerComputation,
            answerComputationOptions: options,
            searchModel,
            searchModelTriggerStrategyClass: searchModelTriggerStrategyClassFromType(searchModelTriggerStrategy),
            silent: true,
            application: options.application,
            searchModelOptions,
            answerInputPresets: attributes
        };
        const wiring = new AnswerComputeWiring(input, output, wiringOptions);
        return new AnswerModel(wiring, {});
    }
    function createSearchResponseAnswerModel(options, searchModel) {
        const searchModelTriggerStrategy = SearchModelTriggerStrategyType.TriggerOnComputed;
        const input = new AnswerInputModel({});
        const output = new AnswerOutputModel({});
        const wiringOptions = {
            answerComputationClass: RetrievalDetailsAnswerComputation,
            answerComputationOptions: options,
            searchModel,
            searchModelTriggerStrategyClass: searchModelTriggerStrategyClassFromType(searchModelTriggerStrategy),
            silent: true,
            application: options.application,
            answerInputPresets: {}
        };
        const wiring = new AnswerComputeWiring(input, output, wiringOptions);
        return new AnswerModel(wiring, {});
    }
    class RAGAnswerLegacyModelAdapter {
        constructor(answerModel) {
            var _a;
            this.model = new backbone_1.default.Model({});
            // @ts-ignore
            (_a = answerModel === null || answerModel === void 0 ? void 0 : answerModel.output) === null || _a === void 0 ? void 0 : _a.on('change', function (model, changedAttrs) {
                this.model.set(this.transform(model.attributes));
            }.bind(this));
            // @ts-ignore
            answerModel === null || answerModel === void 0 ? void 0 : answerModel.on('computed', function () {
                this.model.set("is_streaming", null);
            }.bind(this));
        }
        transform(attributes) {
            let transformedAttributes = Object.assign({}, attributes, {
                ai_answer_disabled: true,
                generated_text: attributes.generated_text,
                is_streaming: attributes.computing || null,
                telemetryEnabled: client_config_1.default.getTelemetryEnabled()
            });
            return Object.assign({}, this.model.toJSON(), transformedAttributes);
        }
        getModel() {
            return this.model;
        }
    }
    exports.RAGAnswerLegacyModelAdapter = RAGAnswerLegacyModelAdapter;
});
